import Navbar from "../../components/Navbar/Navbar";
import LoadingWell from "../../components/Loading/LoadingWell";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./About.css";

import { useEffect, useState } from "react";
import axios from "axios";


export default function About() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const openModal = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  useEffect(() => {
    document.title = "Kútonline - Rólunk";
  }, []);

  useEffect(() => {
    setLoading(true);
    setLoadError(false);

    const timeout = setTimeout(() => {
      setLoadError(true);
      setLoading(false);
    }, 5000);

    axios.get(`${apiUrl}/teammembers`)
      .then(res => setTeamMembers(res.data))
      .catch(() => {
        setTeamMembers([]);
        setLoadError(true);
      })
      .finally(() => {
        setLoading(false);
        clearTimeout(timeout);
      });

    return () => clearTimeout(timeout);
  }, [apiUrl]);

  

  return (
    <div>
      <title>Kútonline - Rólunk</title>
      <Navbar />
      <DarkModeButton />

      <section className="about-team-banner">
        <div className="about-team-banner-text">
          <h2>Kik vagyunk mi?</h2>
          <p>A Kút Online újság létrejöttét a Vasi Kutatócsoport hároméves munkája előzte meg. A kutatócsoport olyan nyugat-dunántúli fiatalokból áll, akiket elsősorban a néptánc kötött össze. Az újság szerkesztősége is ebből a csoportból került ki. A tagok között van történész, néprajzos, közösségszervező, pedagógus, fodrász és gimnazista is. A Kút Online számunkra közösségi tér is, ahol több szakma tapasztalatának segítségével mutatjuk be a néphagyomány múltját és jelenét, fontos célunk a korszakokon átívelő ismeretterjesztés.</p>
        </div>
        <div className="about-team-banner-image"></div>
      </section>

      <div className="page-container">
        <h2>Tagjaink</h2>
        <p>Ismerd meg csapatunkat!</p>
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <LoadingWell />
          </div>
        ) : loadError ? (
          <div style={{textAlign: 'center', padding: '2rem', color: '#b00'}}>
            <span>Nem sikerült betölteni a csapat tagjait. Kérjük, próbáld újra később!</span>
          </div>
        ) : (
          <section className="about-team-section">
            {teamMembers.map(member => (
              <div className="about-team-member" key={member.id} onClick={() => openModal(member)} style={{cursor: 'pointer'}}>
                <img src={member.image ? member.image : "/images/member/member-placeholder.jpg"} alt={member.name} />
                <h3>{member.name}</h3>
                <p>{member.position}</p>
              </div>
            ))}
          </section>
        )}
      </div>

      {showModal && selectedMember && (
        <div
          className="about-modal"
          onClick={closeModal}
        >
          <div
            className="about-modal-content"
            onClick={e => e.stopPropagation()}
          >
            <span className="about-modal-close" onClick={closeModal} >&times;</span>
            <img src={selectedMember.image ? selectedMember.image : "/images/member/member-placeholder.jpg"} alt={selectedMember.name} style={{width:'100%', borderRadius:8, marginBottom:10}} />
            <h3>{selectedMember.name}</h3>
            <p><strong>{selectedMember.position}</strong></p>
            <p>{selectedMember.description}</p>
          </div>
        </div>
      )}
      <ScrollToTopButton />
    </div>
  );
}